import { twMerge } from 'tailwind-merge'

type Props = {
  count: number
  className?: string
}

export function FilterBadge({ count, className }: Props) {
  if (count === 0) return null

  return (
    <span
      className={twMerge(
        `flex aspect-square h-5 items-center justify-center gap-1 rounded border-[0.5px] border-default bg-primary-alpha-8 px-1.5 py-0.5 text-label-xs text-primary-700`,
        className,
      )}
    >
      {count}
    </span>
  )
}
